import {create} from './factory';

export const deviceService = create();
